import React, { Fragment } from 'react';

import { useIntl } from 'react-intl-next';

import { Spotlight } from '@atlaskit/onboarding';

import {
	SPOTLIGHT_ONBOARDING_STEP1_TARGET,
	SPOTLIGHT_ONBOARDING_STEP2_TARGET,
} from '../../../common/constants/spotlight';
import { useAvailableProducts } from '../../../controllers/store';
import { useSpotlightState } from '../../../controllers/store/spotlight';

import messages from './messages';

export const SearchPageOnboardingSpotlight = () => {
	const { formatMessage } = useIntl();
	const [spotlight, { next, dismiss }] = useSpotlightState();
	const [availableProducts] = useAvailableProducts();

	const renderSpotlight = spotlight.state === 'visible' && availableProducts.length > 0; // Only render the spotlight after available products have been fetched

	if (!renderSpotlight) {
		return null;
	}

	const renderActiveSpotlight = () => {
		const spotlights = [
			<Spotlight
				actionsBeforeElement={formatMessage(messages.onboardingStep1Progress)}
				actions={[
					{
						onClick: () => {
							next();
						},
						text: formatMessage(messages.next),
					},
					{
						onClick: () => {
							dismiss();
						},
						text: formatMessage(messages.dismiss),
						appearance: 'subtle',
					},
				]}
				heading={formatMessage(messages.onboardingStep1Heading)}
				target={SPOTLIGHT_ONBOARDING_STEP1_TARGET}
				key={SPOTLIGHT_ONBOARDING_STEP1_TARGET}
				dialogWidth={275}
				dialogPlacement="left top"
				targetRadius={8}
			>
				{formatMessage(messages.onboardingStep1Description)}
			</Spotlight>,
			<Spotlight
				actionsBeforeElement={formatMessage(messages.onboardingStep2Progress)}
				actions={[
					{
						onClick: () => {
							dismiss();
						},
						text: formatMessage(messages.done),
					},
				]}
				heading={formatMessage(messages.onboardingStep2Heading)}
				target={SPOTLIGHT_ONBOARDING_STEP2_TARGET}
				key={SPOTLIGHT_ONBOARDING_STEP2_TARGET}
				dialogWidth={275}
				targetRadius={8}
			>
				{formatMessage(messages.onboardingStep2Description)}
			</Spotlight>,
		];

		return spotlights[spotlight.activeSpotlight];
	};

	return <Fragment>{renderActiveSpotlight()}</Fragment>;
};
